import useLocale from "@/vue/composables/useLocale";

const getSiteFromDomain = (domain: string, language: string) => {
	// For local development or preprod QA, we use the language as the domain
	if (domain === 'localhost' || domain === 'migdal.travelfactory.fr') {
		// const locale = useLocale()
		// For dev
		const locale = 'en_US';
		// domain = language;
		domain = {
			"en_US": "www.uk.travelski.com",
			// "fr_FR": "www.travelski.com",
			"fr_FR": "www.befr.yoonly.eu",
			// "nl_NL": "www.nl.travelski.com",
			"nl_NL": "www.nl.yoonly.eu",
			"fr_FR_CSE": "cse.travelski.com"
		}[locale]
	}

	switch (domain) {
		case "nl-NL":
		case "nl_NL":
		case "nl.travelski.com":
		case "www.nl.travelski.com": {
			return 'www.nl.travelski.com';
		}
		case "en-US":
		case "en_US":
		case "en-GB":
		case "en_GB":
		case "uk.travelski.com":
		case "preprod2.travelski.com":
		case "www.uk.travelski.com": {
			return 'www.uk.travelski.com';
		}
		case "cse.travelski.com": {
			return 'cse.travelski.com';
		}
		case "www.befr.yoonly.eu": {
			return 'www.befr.yoonly.eu';
		}
		default: {
			return 'www.travelski.com';
		}
	}
};

export default getSiteFromDomain;
